import styled from "styled-components";

export const MediaForm = styled.form(() => `
    width: 100%;
`)